const bp = {
  SM: 576,
  LG: 1024,
  XL: 1220,
};

export default bp;



// WEBPACK FOOTER //
// ./src/javascript/main/vars.js